import * as Types from '../constants/Types';

const initialState = {
    onSubmitting: false,
};

export default (state = initialState , action) => {
    switch (action.type) {
        case Types.CUSTOMER_LIST_ACTION:
            return {...state,isFetching: true};
        case Types.CUSTOMER_GET_ITEM_ACTION:
            return {...state,isFetchingUpdate: true};
        case Types.CUSTOMER_LIST_SUCCESS:
            return {...state, isFetching: false, data: action.customers};
        case Types.CUSTOMER_GET_ITEM_SUCCESS:
            return {...state, isFetchingUpdate: false, customerUpdate: action.itemCustomer};
        case Types.CUSTOMER_FILTER_GET_ALL_SUCCESS:
            return {...state, allCustomer: action.allCustomer};
        case Types.CUSTOMER_EXPORT_SUCCESS:
            return {...state, isFetchingUpdate: false, dataEx: action.exCustomer};
        default:
            return state;
    }
}